// extracted by mini-css-extract-plugin
export default {"container":"Footer__container___ob4wQ","containerV2":"Footer__containerV2___O8GZ1","footerInnerContainer":"Footer__footerInnerContainer___Xmgbe"};